import { gql, useQuery } from '@apollo/client'
import { useEffect, useState } from 'react';

const GET_CART_DATA = gql`
    query getCart {
  cart {
    id
    programId
    courseId
    course {
      id
      price
      openedxCourseId
      _CourseOverviewsCourseoverview {
        courseImageUrl
        displayName
        id
        shortDescription
      }
    }
    program {
      price
      name
      image
      id
    }
    createdAt
    userId
    status
    organisationId
  }
}
`

const useFetchCart = () => {
    const [draftCartData, setDraftCartData] = useState([])
    const [wishlistCartData, setWishlistCartData] = useState([])
    const { data, loading, error, refetch } = useQuery(GET_CART_DATA, {
            context: {
                headers: {
                        'x-hasura-role': 'learner',
                },
            }
        }
    )
    useEffect(() => {
        if (data?.cart) {
            setDraftCartData(data.cart.filter(item => item.status === 'draft' || item.status === 'pending'))
            setWishlistCartData(data.cart.filter(item => item.status === 'wishlist'))
        }
    }, [data])
    return { data, loading, error, refetch, draftCartData, wishlistCartData }
}

export default useFetchCart